import React, { useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom/client';
import SocketContextProvider from './contexts/SocketContextProvider';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider, useDispatch } from 'react-redux';
import { getUrlElement, pullQueryString } from './utils/common';
import store, { AppDispatch } from './redux/store'; // Import the store and AppDispatch type
import { pullConfig, pullPlayers } from './redux/actions'; // Import the action
import NotFound from './containers/NotFound/NotFound';
import { BrowserRouter as Router } from 'react-router-dom';

const RootComponent: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>(); // Specify the correct dispatch type
  const [isConfigAvailable, setIsConfigAvailable] = useState(true);

  // Language mapping
  const langMap: Record<string, string> = {
    "in": "en-IN",
    "kz": "kk",
    "sc": "zh-Hans",
    "kr": "ko-KR",
    "vn": "vi",
    "bd": "bn-BD",
    "pk": "en-PK",
    "np": "ne",
    "ch": "zh-Hant",
    "eu": "en",
    // Add more mappings as needed
  };

  let pageType = 'chat';
  let lang = getUrlElement(4);
  let brand = getUrlElement(5);
  const s = pullQueryString('s');

  if (brand === "mc-desktop") {
    brand = "dafabet";
  }
  if (lang === "call") {
    lang = pullQueryString('lang') ?? 'en';
    pageType = 'call';
  }

  // Map language code using langMap
  if (langMap[lang]) {
    lang = langMap[lang];
  }

  // Memoize data
  const data = useMemo(() => ({ brand, lang }), [brand, lang]);

  useEffect(() => {
    const fetchConfigData = async () => {
      const result = await dispatch(pullConfig({ data, pageType }));
      console.log(result.payload);
      console.log("Code reflectingggggggggg");
      
      if (result.payload) {
        setIsConfigAvailable(true);
      } else {
        setIsConfigAvailable(false);
      }
    };

    fetchConfigData();
  }, [dispatch, data]);

  useEffect(() => {
    if (s) {
      dispatch(pullPlayers(s)); // Fetch player data based on 's' value
    }
  }, [dispatch, s]);

  if (!isConfigAvailable) {
    return <Router>
      <NotFound />
    </Router>;
  }

  return <Router>
    <App brand={brand} lang={lang}/>
  </Router>;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <SocketContextProvider>
      <RootComponent />
    </SocketContextProvider>
  </Provider>
);

reportWebVitals();
